import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields, twoFactorClient } from 'better-auth/client/plugins';
import { jwt } from 'better-auth/plugins';
import { passkeyClient } from '@better-auth/passkey/client';
import { sentinelClient } from "@better-auth/infra/client";
// import { passkey } from "@better-auth/passkey"

export const authClient = createAuthClient({
    baseURL: `${process.env.REACT_APP_API_URL}`, // the base url of your auth server
    fetchOptions: {
        auth: {
            type: 'Bearer',
            token: () => localStorage.getItem('GCToken') || '',
        },
        onSuccess: (ctx) => {
            // console.log("onSuccess")
            const authToken = ctx.response.headers.get("set-auth-token") // get the token from the response headers
            // Store the token securely (e.g., in localStorage)
            if (authToken) {
                localStorage.setItem("GCToken", authToken)
            }
        },
        onResponse: (ctx) => {
            // console.log(Object.fromEntries(ctx.response.headers.entries()))
            const authToken = ctx.response.headers.get("set-auth-token")
            const jwt = ctx.response.headers.get("set-auth-jwt") // get the token from the response headers
            // Store the token securely (e.g., in localStorage)
            // console.log(authToken);
            if (authToken) {
                // console.log("got an auth token")
                localStorage.setItem("GCToken", authToken)
            }
            if (jwt) {
                localStorage.setItem("GCJWT", jwt)
            }
        }
    },
    plugins: [
        sentinelClient(),
        inferAdditionalFields({
            user: {
                dob: { type: 'date' },
                firstName: { type: 'string' },
                lastName: { type: 'string' },
                displayName: { type: 'string' }
            }
        }), jwt({
            jwt: {
                expirationTime: '5m',
                definePayload: (user) => {
                    return {
                        // @ts-ignore
                        id: user.id,
                        // @ts-ignore
                        email: user.email,
                    }
                }
            }
        }),
        twoFactorClient({
            // onTwoFactorRedirect() {
            //     window.location.href = `${process.env.REACT_APP_URL}login/verify`;
            // }
        }),
        passkeyClient()
        
    ],
    session: {
        expiresIn: 60 * 60 * 24 * 7, // 7 days
        updateAge: 60 * 60 // 1 day (every 1 day the session expiration is updated)
    }
    // user: {
    //     additionalFields: {
    //         dob: { type: 'date', required: true },
    //         firstName: { type: 'string', required: true },
    //         lastName: { type: 'string', required: true },
    //     }
    // }
});